import { useState, useEffect } from "react";

const LocationSelector = ({
  userAddr,
  onSelectionChange,
  statesAndCitiesData,
}) => {
  const [selections, setSelections] = useState({
    stateId: "",
    districtId: "",
    tehsilId: "",
    placeId: "",
  });

  const [lists, setLists] = useState({
    districts: [],
    tehsils: [],
    places: [],
  });

  // console.log("addr==============", userAddr);
  useEffect(() => {
    if (!statesAndCitiesData) return; // Wait for data to arrive from parent
    if (!userAddr || userAddr.length < 3) return; // Wait for meaningful input

    const addr = userAddr.toLowerCase();
    let foundState = null;
    let foundDist = null;
    let foundTehsil = null;
    let foundPlace = null;
    // console.log("addr==============", addr);

    // 1. Find District and its parent State
    for (const state of statesAndCitiesData.states) {
      // console.log("checking districts of ===============", state.name);
      const matchDist = state.districts.find(
        (d) =>
          addr.includes(d.name.toLowerCase()) ||
          (d.hindiName && addr.includes(d.hindiName)),
      );
      if (matchDist) {
        foundState = state;
        foundDist = matchDist;
        // console.log("found matching dist===============", foundDist);
        break; // Stop at first matching district
      }
    }

    if (foundDist) {
      // 2. Jump straight to looking for a Place within this District's tehsils
      for (const tehsil of foundDist.tehsils) {
        const matchPlace = tehsil.places.find(
          (p) =>
            addr.includes(p.name.toLowerCase()) ||
            (p.hindiName && addr.includes(p.hindiName)),
        );

        if (matchPlace) {
          foundTehsil = tehsil;
          foundPlace = matchPlace;
          break; // Found the place, so we know the tehsil too
        }
      }

      // 3. Fallback: If no place matched, check if at least a Tehsil name matches
      if (!foundTehsil) {
        foundTehsil = foundDist.tehsils.find(
          (t) =>
            addr.includes(t.name.toLowerCase()) ||
            (t.hindiName && addr.includes(t.hindiName)),
        );
      }

      const newUpdate = {
        stateId: foundState.id,
        districtId: foundDist.id,
        tehsilId: foundTehsil ? foundTehsil.id : "",
        placeId: foundPlace ? foundPlace.id : "",
      };

      setSelections(newUpdate);
      setLists({
        districts: foundState.districts,
        tehsils: foundDist.tehsils,
        places: foundTehsil ? foundTehsil.places : [],
      });
      onSelectionChange(newUpdate);
    }
  }, [userAddr, statesAndCitiesData]);

  // Manual Handlers (Simplified version)
  const handleManualChange = (level, id) => {
    if (!statesAndCitiesData) return;
    // console.log("manual handler called............");
    let updated = { ...selections, [level]: id };

    if (level === "stateId") {
      const s = statesAndCitiesData.states.find((x) => x.id === id);
      updated = { stateId: id, districtId: "", tehsilId: "", placeId: "" };
      setLists({ districts: s ? s.districts : [], tehsils: [], places: [] });
    } else if (level === "districtId") {
      const d = lists.districts.find((x) => x.id === id);
      updated = { ...selections, districtId: id, tehsilId: "", placeId: "" };
      setLists((prev) => ({
        ...prev,
        tehsils: d ? d.tehsils : [],
        places: [],
      }));
    } else if (level === "tehsilId") {
      const t = lists.tehsils.find((x) => x.id === id);
      updated = { ...selections, tehsilId: id, placeId: "" };
      setLists((prev) => ({ ...prev, places: t ? t.places : [] }));
    } else if (level === "placeId") {
      updated = { ...selections, placeId: id };
    }

    setSelections(updated);
    onSelectionChange(updated);
  };

  if (!statesAndCitiesData) {
    return null;
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      <select
        id="stateSelector"
        value={selections.stateId}
        onChange={(e) => handleManualChange("stateId", e.target.value)}
      >
        <option value="">Select State</option>
        {statesAndCitiesData.states.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>

      <select
        id="districtSelector"
        value={selections.districtId}
        onChange={(e) => handleManualChange("districtId", e.target.value)}
        disabled={!selections.stateId}
      >
        <option value="">Select District</option>
        {lists.districts.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}
          </option>
        ))}
      </select>

      <select
        id="tehsilSelector"
        value={selections.tehsilId}
        onChange={(e) => handleManualChange("tehsilId", e.target.value)}
        disabled={!selections.districtId}
      >
        <option value="">Select Tehsil</option>
        {lists.tehsils.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </select>

      <select
        id="placeSelector"
        value={selections.placeId}
        onChange={(e) => handleManualChange("placeId", e.target.value)}
        disabled={!selections.tehsilId}
      >
        <option value="">Select Place</option>
        {lists.places.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LocationSelector;
